// extracted by mini-css-extract-plugin
export var formContainer = "_ih-0";
export var message = "_ih-1";